import styled from "styled-components"
import { device } from "breakpoints"

export const Container = styled.div`
  padding-bottom: 47px;
  max-width: 1160px;

  @media ${device.desktop} {
    /* padding-top: 91px; */
    padding-bottom: 78px;
  }
`
